module.exports = __webpack_public_path__ + "static/img/surface2.8674570.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/surface2.png
// module id = UeXP
// module chunks = 2